import { api } from './api';

export const fetchAccessDevices = (params, options) => {
  const payload = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => payload.append(key, item));
    else return payload.append(key, value);
  });

  return api.get('/access_device', params, options);
};

export const fetchAccessDeviceById = (id) => {
  return api.get(`/access_device/${id}`);
};

export const createAccessDevice = (payload) => {
  return api.post(`/access_device`, payload);
};

export const updateAccessDevice = (id, payload) => {
  return api.put(`/access_device/${id}`, payload);
};

export const deleteAccessDevice = (id) => {
  return api.delete(`/access_device/${id}`);
};

export const assignAccessDevice = (payload) => {
  return api.post('/access_device/assign', payload);
};

export const unassignAccessDevice = (payload) => {
  return api.post('/access_device/unassign', payload);
};

export const addBrokerToAccessDevice = (id, payload) => {
  return api.post(`/access_device/${id}/broker`, payload);
};

export const removeBrokerFromAccessDevice = (id, broker) => {
  return api.delete(`/access_device/${id}/broker/${broker}`);
};
